import "./Pages.css";
export default function Bar() {
  return (
    <section className="titulo">
      <h2>Bar / Bebidas</h2>
      <div className="subtitulo">
        <p>Drinks, batidas, cervejas e bebidas alcoólicas selecionadas para complementar a sua festa com qualidade e sofisticação.</p>
      </div>
      <div className="img-container">
        <img loading="lazy" src="/images-webp/Bebidas/bebidas5.webp" alt="bebidas" />
        <img loading="lazy" src="/images-webp/Bebidas/bebidas.webp" alt="bebidas" />
        <img loading="lazy" src="/images-webp/Bebidas/bebidas2.webp" alt="bebidas" />
        <img loading="lazy" src="/images-webp/Bebidas/bebidas4.webp" alt="bebidas" />
        <img loading="lazy" src="/images-webp/Bebidas/bebidas6.webp" alt="bebidas" />
        <img loading="lazy" src="/images-webp/Bebidas/bar.webp" alt="bar" />
        <img loading="lazy" src="/images-webp/Bebidas/bar3.webp" alt="bar" />
        <img loading="lazy" src="/images-webp/Bebidas/bar4.webp" alt="bar" />
        <img loading="lazy" src="/images-webp/Bebidas/bar2.webp" alt="bar" />
      </div>
    </section>
  );
}
